import { Component } from "react"
import { SomethingWentWrongPage } from "./SomethingWentWrongPage"
import { trackException } from "@rawa/telemetry"

type Props = { children: React.ReactNode }
type State = { hasError: boolean }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    trackException(error, {
      componentStack: info.componentStack ?? "",
      source: "ErrorBoundary",
    })
  }

  render() {
    if (this.state.hasError) return <SomethingWentWrongPage />
    return this.props.children
  }
}
